export default "__VITE_ASSET__BIHxYhME__"